// Slug helpers — mirror dari /app/backend/models/tenant.py
export function slugify(text) {
  if (!text) return "";
  return String(text)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 40);
}

// Return null kalau valid, atau string error message kalau tidak.
export function validateSlug(slug) {
  if (!slug || typeof slug !== "string") return "Slug wajib diisi.";
  const s = slug.trim();
  if (s.length < 3 || s.length > 40) return "Slug harus 3-40 karakter.";
  if (s !== s.toLowerCase()) return "Slug harus lowercase.";
  if (!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(s)) {
    return "Slug hanya boleh berisi huruf, angka, dan dash (contoh: toko-maju-jaya).";
  }
  return null;
}
